export const UPDATE_DATA = 'app/EditSessionPage/Number/UPDATE';
export const UPDATE_VARIABLE = 'app/EditSessionPage/Number/UPDATE_VARIABLE';
